export default __webpack_public_path__ + "static/media/l3-p3.91cf6494.svg";